exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-wrapper .img-wrap[data-v-655958f6]{position:relative;width:100%;height:180px;line-height:180px;border:1px solid #c0ccda;border-radius:4px;text-align:center}.upload-wrapper .img-wrap img[data-v-655958f6]{position:absolute;left:0;right:0;top:0;bottom:0;width:100%;height:100%;object-fit:contain}.upload-wrapper .img-close[data-v-655958f6]{position:absolute;top:-7px;right:-7px;padding:0}.upload-wrapper .upload-tips[data-v-655958f6]{text-align:left!important;line-height:1;margin:0}.el-dragger__text[data-v-655958f6]{padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-655958f6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UploadItems/UploadImage.vue
// module id = 559
// module chunks = 0